const { createContext } = require('react');

const ProfileUserContext = createContext({});

module.exports = { ProfileUserContext };
